import {
  EditOutlined,
  MoreOutlined,
  PlayCircleOutlined,
} from '@ant-design/icons'
import { User } from 'Components'
import { Button, Dropdown, Menu, message } from 'antd'
import { Link, useParams } from 'react-router-dom'
import { store } from '~/Store'
import moment from 'moment'

const RunNow = ({ uid, setExpandedRowKey, setShowConfig }) => {
  const { explore: { plugins }} = store.getState()
  const orchestrator = plugins['weaver-orchestrator']

  return (
    <>
      <Button
        type='text'
        onClick={() => {
          setExpandedRowKey(uid)
          setShowConfig(true)
        }}
        icon={<EditOutlined style={{ color: 'green' }}/>}
      />
      <Button
        type='text'
        onClick={
          _.debounce(async () =>{
            await orchestrator.addCron({
              scheduleUid: uid,
              runOnce: true,
              firstRun: moment().utc().valueOf()/1000,
              cron: {}
            })
            setExpandedRowKey(uid)
          },
          1000,
          { leading: true, trailing: false }
        )}
        icon={<PlayCircleOutlined style={{ color: 'green' }}/>}
      />
    </>
  )
}

const ActionsMenu = ({ task }) => {

  const { crons, uid } = task;
  const { spaceId } = useParams()
  const { explore: { plugins }} = store.getState()
  const orchestrator = plugins['weaver-orchestrator']

  const disableCrons = async () => {
    const toBeDisabled = crons.filter((cron) => cron.runOnce === false)

    await new Promise.map(toBeDisabled, (cron) => {
      const updatedCronObj = {
        cronUid: cron.uid,
        runOnce: false,
        firstRun: -1,
        cron: {}
      }
      orchestrator.updateCron(updatedCronObj)
    })
  }

  crons.find((cron) => cron.value !== undefined)

  const items = [
    {
      key: `edit-${uid}`,
      label: <Link to={`/${ spaceId }/pipelines/tasks/${uid}`}>Edit</Link>,
    }, {
      key: `disable-${uid}`,
      disabled: !crons.find(({ cron }) => cron.value !== undefined),
      label: <a target="_blank">Disable</a>,
      danger: true,
      onClick: async () => {
        await disableCrons()
        message.success(`Disabled crons for ${uid}`)
      }
    }
  ]

  return (
    <Menu items={items} />
  )
}

const sortingFn = (a, b) => {
  if (a < b) {
    return -1
  } else if (a > b) {
    return 1
  } else {
    return 0
  }
}

export const tableColumns = (setExpandedRowKey, setShowConfig) => {
  return [
    {
      title: 'Functionality',
      dataIndex: 'functionalityName',
      key: 'job',
      render: (functionalityName) => _.startCase(functionalityName),
      sorter: (a, b) => sortingFn(a.functionalityName, b.functionalityName)
    }, {
      title: 'Created (UTC)',
      dataIndex: 'created',
      key: 'created',
      render: (createdMoment) => moment.utc(createdMoment, "YYYY-MM-DDTHH:mm:ss.SSSSZ").format("ddd, DD MMM YYYY, HH:mm"),
      sorter: (a, b) => {
        const first = moment(a.created, "YYYY-MM-DDTHH:mm:ss.SSSSZ").valueOf()
        const second = moment(b.created, "YYYY-MM-DDTHH:mm:ss.SSSSZ").valueOf()
        return sortingFn(first, second)
      }
    }, {
      title: 'Branch',
      dataIndex: 'branch',
      key: 'branch',
      sorter: (a, b) => sortingFn(a.branch, b.branch)
     }, {
       title: 'User',
       dataIndex: 'userId',
       key: 'userId',
       render: (userId) => <User userId={userId}/>
    }, {
      title: 'Run Now',
      dataIndex: 'uid',
      key: 'runNow',
      render: (uid) => {
        return (
          <RunNow
            setShowConfig={setShowConfig}
            setExpandedRowKey={setExpandedRowKey}
            uid={uid}
          />
        )
      }
    }, {
      title: 'Actions',
      dataIndex: '',
      key: 'actions',
      render: (task) =>
        <Dropdown
          overlay={<ActionsMenu task={task}/>}
        >
          <MoreOutlined />
        </Dropdown>
    },
  ]
}
